import dayjs from "dayjs"

import { faIcon } from "@utils/faIcon"
import formatRecurrence, { formatRecurrenceShorthand } from "@utils/formatRecurrence"

import { Badge } from "@atoms"

import { RecurrenceBadgeProps } from "./RecurrenceBadge.types"

const icon = faIcon({ name: "arrows-repeat", style: "regular" })

export default function RecurrenceBadge(props: RecurrenceBadgeProps) {
    const { interval, frequency, startDate, weeklyRecurrence, monthlyRecurrence, endDate, size = "md" } = props

    const shorthand = formatRecurrenceShorthand(frequency, interval)

    // e.g. "Repeats\nEvery Month on day 4\nuntil January 1, 2025".
    const lines = [
        "Repeats",
        formatRecurrence({ interval, frequency, startDate, weeklyRecurrence, monthlyRecurrence }),
    ]
    if (endDate) {
        lines.push(`until ${dayjs(endDate).format("MMMM D, YYYY")}`)
    }

    return (
        <Badge size={size} variant="icon" icon={icon} tooltip={lines.join("\n")}>
            {shorthand}
        </Badge>
    )
}
